import { useState } from "react";
import Spinner from "./Spinner";

export default function ContentListSearchAutocomplete(props: {
  onComplete: any;
  placeHolder: string;
  className?: string;
  value?: string;
}) {
  const [searchLoading, setSearchLoading] = useState(false);
  const [currentTimeout, setCurrentTimeout] = useState(undefined as any);

  const onSearchHandler = (searchString: any) => {
    setSearchLoading(true);
    if (currentTimeout) clearTimeout(currentTimeout);
    let timeout = setTimeout(() => {
      props.onComplete(searchString);
      setSearchLoading(false);
    }, 500);
    setCurrentTimeout(timeout);
  };

  return (
    <div className="w-full h-full flex border border-accent border-opacity-5 rounded-lg bg-base-200">
        <div className="w-full h-full">
          <input
            defaultValue={props?.value}
            type="text"
            onChange={(event) => onSearchHandler(event.target.value)}
            placeholder={props.placeHolder}
            className={`input bg-base-200 placeholder:text-accent placeholder:text-opacity-50 w-full h-full rounded-r-none focus:outline-none text-sm border-hidden ${props.className}`}
          />
        </div>
        <div
          className={`w-1/12 flex items-center justify-center rounded-r-lg bg-base-200  ${props.className}`}
        >
          {searchLoading ? <Spinner heigt="h-5"></Spinner> : ""}
        </div>
      </div>
  );
}
